import React, { useState, useEffect } from "react";
import "./Navbar.css";
import {
  download_notice_insert_view_log_api,
  getUserDetails,
  get_new_guideline_icon_count,
  get_new_notice_icon_count,
  get_unseen_guideline,
  get_unseen_notices,
} from "../../api/Users";
import { FaBell } from "react-icons/fa";
import { motion } from "framer-motion";
import user from "../../images/userIcon.png";
import { baseUrl } from "../../api/constant";
import { useForm } from "react-hook-form";
import i18next from "i18next";
import Languageoption from "../Language-Dropdown";
import { useNavigate } from "react-router";
import { get_cart_items } from "../../api/Products";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { MDBTypography } from "mdb-react-ui-kit";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Modal } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import AssignmentIcon from "@mui/icons-material/Assignment";


import { toast } from "react-toastify";

const Navbar = ({ role, userData }) => {
  const { t } = useTranslation();

  const [newNotice, ShowNewNotice] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [newCount, setNewCount] = useState(0);

  const [newGuideline, ShowNewGuideline] = useState(false);
  const [modalGOpen, setModalGOpen] = useState(false);
  const [newGCount, setNewGCount] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [filteredGData, setFilteredGData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedGRow, setSelectedGRow] = useState(null);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseGModal = () => {
    setModalGOpen(false);
  };

  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
    localStorage.setItem("selectedLanguage", e.target.value);
  };

  // Define variables
  const [fullName, setFullName] = useState();
  const [roleName, setRoleName] = useState();
  const [imgPath, setImgPath] = useState(user);

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleMouseEnter = () => {
    handleOpenModal();
  };

  const handleMouseLeave = () => {
    console.log("Mouse has left the component");
    handleCloseModal();
  };

  const handleOpenGModal = () => {
    setModalGOpen(true);
  };

  const handleGMouseEnter = () => {
    handleOpenGModal();
  };

  const handleGMouseLeave = () => {
    setModalGOpen(false);
  };

  useEffect(() => {
    setIsLoading(true);
    get_unseen_notices()
      .then((response) => {
        if (response.status == "success") {
          setFilteredData(response.data.result);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });

    get_new_notice_icon_count()
      .then((response) => {
        if (response.status == "success") {
          ShowNewNotice(true);
          setNewCount(response.data.result[0].unseen_notices_count);
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });

    get_unseen_guideline()
      .then((response) => {
        if (response.status == "success") {
          setFilteredGData(response.data.result);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });

    get_new_guideline_icon_count()
      .then((response) => {
        if (response.status == "success") {
          ShowNewGuideline(true);
          console.log();
          setNewGCount(response.data.result[0].unseen_notices_count);
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });

    if (userData.status === "success") {
      setFullName(capitalizeFirstLetter(userData.data.name));
      if (userData.data.img_path) {
        setImgPath(baseUrl() + userData.data.img_path);
      }
      // set roles
      if (userData.data.role_id === 1) {
        setRoleName("Head Office");
      } else if (userData.data.role_id === 2) {
        setRoleName("School");
      } else if (userData.data.role_id === 3) {
        setRoleName("Assistant Head Master");
      } else if (userData.data.role_id === 4) {
        setRoleName("Head Master");
      } else if (userData.data.role_id === 5) {
        setRoleName("Welfare Extension Officer");
      } else if (userData.data.role_id === 6) {
        setRoleName("District Welfare Officer");
      } else if (userData.data.role_id === 7) {
        setRoleName("District Magistrate");
      } else if (userData.data.role_id === 8) {
        setRoleName("Head Office");
      } else if (userData.data.role_id === 9) {
        setRoleName("Teacher");
      } else if (userData.data.role_id === 10) {
        setRoleName("Student");
      } else if (userData.data.role_id === 14) {
        setRoleName("Admin");
      }
    }
  }, [userData]);

  let navigate = useNavigate();

  const handleUpdateClick = (row) => {
    setModalOpen(true);
  };

  const goToNotices = () => {
    navigate("/view-notices");
    setModalOpen(false);
  };

  const handleDownload = (row) => {
    console.log(row);
    if (!row || !row.attachment_path) {
      console.error("Attachment path is missing.");
      return;
    }

    const currentDate = new Date()
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");

    const path = row.attachment_path;
    const filename = path.split("/").pop();

    const data = {
      notice_id: row.id,
      view_date: currentDate,
      filePath: row.attachment_path,
      fileName: filename,
    };
    download_notice_insert_view_log_api(data)
      .then((response) => {
        if (response.status == "success") {
          toast.success("Notice Downloaded");
        }
      })
      .catch((error) => {
        console.error("Error fetching new notices:", error);
      });
  };

  return (
    <>
      <div className="container1 justify-content-between px-2 hide-on-print">
        <div className="userName mt-md-2">
          <p>
            <strong id="fullName">{fullName}</strong>
          </p>
          <p className="smallText">{roleName}</p>
        </div>
        <div className="d-flex align-items-center col-gap">
          {role !== 8 ? (
            <div
              className="mx-3"
              // onMouseEnter={handleMouseEnter}
              // onMouseLeave={handleMouseLeave}
            >
              {newNotice ? (
                <motion.div
                  className="notification"
                  animate={
                    newNotice
                      ? { x: [-5, 5, -5, 5, 0], rotate: [0, 5, -5, 5, 0] }
                      : ""
                  }
                >
                  <button
                    className="btn position-relative cart p-2 pt-1 pb-1"
                    onClick={handleUpdateClick}
                  >
                    <ContentPasteIcon />
                    {newCount > 0 && (
                      <span class="position-absolute top-40 start-100 translate-middle badge rounded-pill bg-danger text-light border border-2">
                        {newCount}
                      </span>
                    )}
                  </button>
                </motion.div>
              ) : (
                <ContentPasteIcon />
              )}
              <Modal
                show={modalOpen}
                onHide={handleCloseModal}
                // onMouseLeave={handleCloseModal}
                style={{ left: "400px", top: 10 }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t("New Notices")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="Table mb-10 ">
                    <TableContainer className="mt-1">
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Sr. No.")}</TableCell>
                            <TableCell align="left">{t("Notice")}</TableCell>
                            <TableCell align="left">{t("Issue Date")}</TableCell>
                            {/* <TableCell align="left">{t("Expiry Date")}</TableCell> */}
                            <TableCell align="left">{t("Download")}</TableCell>
                          </TableRow>
                        </TableHead>
                        {!isLoading &&
                          filteredData &&
                          filteredData.length > 0 && (
                            <TableBody style={{ color: "white" }}>
                              {filteredData
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      align="center"
                                    >
                                      {index + 1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {row.notice_text}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {new Date(
                                        row.start_date
                                      ).toLocaleDateString("en-GB")}
                                    </TableCell>
                                    {/* <TableCell component="th" scope="row">
                                      {new Date(
                                        row.expiry_date
                                      ).toLocaleDateString("en-GB")}
                                    </TableCell> */}
                                    <TableCell align="right text-dark">
                                      <DownloadIcon
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleDownload(row)}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          )}
                        {!isLoading &&
                          (!filteredData || filteredData.length === 0) && (
                            <TableBody>
                              <TableRow>
                                <TableCell align="center" colSpan={7}>
                                  <h4>
                                    <i>{t("No data available")}</i>
                                  </h4>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                      </Table>
                    </TableContainer>
                    {/* <TablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          ) : (
            ""
          )}
          {role !== 8 ? (
            <div
              // onMouseEnter={handleGMouseEnter}
              // onMouseLeave={handleGMouseLeave}
            >
              {newGuideline ? (
                <motion.div
                  className="notification"
                  animate={
                    newGCount
                      ? { x: [-5, 5, -5, 5, 0], rotate: [0, 5, -5, 5, 0] }
                      : ""
                  }
                >
                  <button
                    className="btn position-relative cart p-2 pt-1 pb-1"
                    onClick={handleOpenGModal}
                  >
                    <AssignmentIcon />
                    {newGCount > 0 && (
                      <span class="position-absolute top-40 start-100 translate-middle badge rounded-pill bg-danger text-light border border-2">
                        {newGCount}
                      </span>
                    )}
                  </button>
                </motion.div>
              ) : (
                <AssignmentIcon />
              )}
              <Modal
                show={modalGOpen}
                onHide={handleCloseGModal}
                // onMouseLeave={handleGMouseLeave}
                style={{ left: "400px", top: 10 }}
              >
                <Modal.Header closeButton>  
                  <Modal.Title>{t("New Guidelines")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="Table mb-6">
                    <TableContainer className="mt-1">
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Sr. No.")}</TableCell>
                            <TableCell align="left">{t("Notice")}</TableCell>
                            <TableCell align="left">{t("Issue Date")}</TableCell>
                            <TableCell align="left">{t("Download")}</TableCell>
                          </TableRow>
                        </TableHead>
                        {!isLoading &&
                          filteredGData &&
                          filteredGData.length > 0 && (
                            <TableBody style={{ color: "white" }}>
                              {filteredGData
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      align="center"
                                    >
                                      {index + 1}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {row.guideline_text}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                      {new Date(
                                        row.start_date
                                      ).toLocaleDateString("en-GB")}
                                    </TableCell>
                                    <TableCell align="right text-dark">
                                      <DownloadIcon
                                        style={{ cursor: "pointer" }}
                                      />
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          )}
                        {!isLoading &&
                          (!filteredGData || filteredGData.length === 0) && (
                            <TableBody>
                              <TableRow>
                                <TableCell align="center" colSpan={7}>
                                  <h4>
                                    <i>{t("No data available")}</i>
                                  </h4>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                      </Table>
                    </TableContainer>
                    {/* <TablePagination
                  rowsPerPageOptions={[10, 25, 50]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          ) : (
            ""
          )}
          <div>
            <Languageoption onChange={(e) => handleClick(e)} />
          </div>
          <Link to={"/profile"}>
            <img
              src={imgPath}
              alt="User"
              className="img-42"
              style={{ cursor: "pointer" }}
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default React.memo(Navbar);
